export default {
    a1:'中文A1'
}   